// Consolidated SchoolCard using generic ItemCard component
import { ItemCard } from './ItemCard';
import { ROUTES } from '../../utils/constants';

/**
 * SchoolCard - Wrapper around ItemCard for school display
 * Maintains backward compatibility while using consolidated component
 *
 * @param {Object} school - School data
 * @param {boolean} active - Active state styling
 * @param {Function} onHover - Hover callback
 * @param {Function} onClick - Click callback
 * @param {Function} onRemove - Remove callback
 * @param {string} variant - Display variant: 'compact', 'result', 'detailed'
 * @param {boolean} enableProfileNavigation - Enable navigation to school profile
 */
const SchoolCard = ({
  school,
  active = false,
  onHover,
  onClick,
  onRemove,
  variant = 'compact',
  enableProfileNavigation = true
}) => {
  if (!school) return null;

  // Build navigation path
  const navigationPath =
    enableProfileNavigation && school.id
      ? `${ROUTES.SCHOOLS}/${school.id}`
      : null;

  return (
    <ItemCard
      type="school"
      data={school}
      variant={variant}
      active={active}
      onClick={onClick}
      onHover={onHover}
      onRemove={onRemove}
      enableNavigation={enableProfileNavigation}
      navigationPath={navigationPath}
    />
  );
};

export { SchoolCard };
